import { API_URL, FAVOURITE } from '@/constants'
import { ApiHandlerResult } from '..'
import { BaseApi } from '../base'
import { RequestInit } from 'next/dist/server/web/spec-extension/request'
import { Fetcher } from '@/api/fetcher'
import { Favourite } from '@/pages/customer/dashboard/[slug]/dashboard'
import type { FavouriteToggleResponse } from '@/pages/api/favourites/toggle'
import type { FavouriteProductsResponse } from '@/pages/api/favourites/products'

// The backend filters on `fav_type`; omitting it returns every type.
type FavouritesGetManyType = {
  fav_type: FAVOURITE
}

export class FavouritesApi extends BaseApi {
  constructor(fetcher: Fetcher) {
    super(fetcher)
  }

  async getMany(
    params?: FavouritesGetManyType,
    options?: RequestInit
  ): ApiHandlerResult<Favourite[]> {
    try {
      const res = await this.fetcher.get(API_URL.FAVOURITES.ROOT, {
        params,
        ...options,
      })

      return await this.parseBodyOrThrow(res)
    } catch (err: any) {
      return [err, null]
    }
  }

  // Use through `api.feTofe` — these two hit Next.js API routes, not the
  // Express backend, which cannot store or return product favourites.
  async toggle(body: {
    object_id: number
    type: FAVOURITE
  }): ApiHandlerResult<FavouriteToggleResponse> {
    try {
      const res = await this.fetcher.post('/favourites/toggle', {
        body: JSON.stringify(body),
      })

      return await this.parseBodyOrThrow(res)
    } catch (err: any) {
      return [err, null]
    }
  }

  async getFavouriteProducts(): ApiHandlerResult<FavouriteProductsResponse> {
    try {
      // The shared Fetcher defaults to a one-hour revalidate, which would serve
      // a stale list right after a product is saved or removed.
      const res = await this.fetcher.get('/favourites/products', {
        cache: 'no-store',
      })

      return await this.parseBodyOrThrow(res)
    } catch (err: any) {
      return [err, null]
    }
  }
}
